import {Component, Input, OnInit} from '@angular/core';
import {EnvironmentService} from '../../service/environment.service';
import {ROUTES} from '../../../app.routes';
import {Message} from 'primeng/message';

@Component({
    selector: 'app-public-page-template',
    templateUrl: './public-page-template.component.html',
    styleUrls: ['./public-page-template.component.scss'],
    standalone: false
})
export class PublicPageTemplateComponent implements OnInit
{
    @Input() headerText?: string;
    @Input() logoOverrideSrc?: string;
    @Input() headerTextAlignment?: TEXT_ALIGNMENT = TEXT_ALIGNMENT.CENTER;
    @Input() showHeaderRule?: boolean = true;
    @Input() showEnvironmentMessage: boolean = false;
    @Input() cardSize?: CARD_SIZE = CARD_SIZE.MD;
    routes = ROUTES;

    alertMessage: Message;

    constructor(
        protected environmentService: EnvironmentService)
    {
    }

    get isProd(): boolean
    {
        return this.environmentService.production &&
            this.environmentService.name.includes('PROD');
    }

    get logoMobile(): string
    {
        return this.environmentService.logoMobile;
    }

    get logoSecondary(): string
    {
        return this.environmentService.logoSecondary;
    }

    get getMainCardSizeClass(): string
    {
        return 'card main-card-' + this.cardSize;
    }

    get isExtraLarge(): boolean
    {
        return this.cardSize === CARD_SIZE.XL;
    }

    get getHeaderTextClasses(): string
    {
        return 'header-text text-' + this.headerTextAlignment;
    }

    ngOnInit()
    {
        this.alertMessage =
            {
                severity: 'error',
                text: `This is the ${this.environmentService.name} environment for ${this.environmentService.instanceName}.`
            } as Message;
    }
}

export enum CARD_SIZE
{
    SM = 'sm', MD = 'md', LG = 'lg', XL = 'xl'
}

export enum TEXT_ALIGNMENT
{
    LEFT = 'left', CENTER = 'center', RIGHT = 'right'
}